import * as React from "react";
import {useContext, useEffect} from "react";
import {BackendToEtaCalculatorEvent} from "../../../../../generated/api";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {ConfigContext} from "../../../context/ConfigContext";
import {Button, Input, Radio} from "semantic-ui-react";
import ReactTable from "react-table";
import {Splitter} from "../../../../util/table-splitter-ui/src/components/Splitters/Splitter";
import AceEditor from "react-ace";
import {formatDate} from "../../../../../format";


export interface EtaCalculatorEventExplorerProps {

}

export function EtaCalculatorEventExplorer(props: EtaCalculatorEventExplorerProps) {

    const context = useContext(ConfigContext)

    const [loading, setLoading] = React.useState(true)
    const [etaCalculatorEvents, setEtaCalculatorEvents] = React.useState<BackendToEtaCalculatorEvent[]>([])
    const [pageSize, setPageSize] = React.useState(25)
    const [pageNumber, setPageNumber] = React.useState(0)
    const [totalElements, setTotalElements] = React.useState(0)
    const [eventId, setEventId] = React.useState("")
    const [transportOrderId, setTransportOrderId] = React.useState("")
    const [processed, setProcessed] = React.useState<boolean | null>(false)
    const [sortBy, setSortBy] = React.useState<'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID'>("ID")
    const [sortDirection, setSortDirection] = React.useState<"ASC" | "DESC">("DESC")
    const [selectedEvent, setSelectedEvent] = React.useState<string | null>(null)

    useEffect(() => {
        setLoading(true)
        fetchData().then(() => setLoading(false))
    }, [pageNumber, pageSize, sortBy, sortDirection])

    async function fetchData() {
        let auth = backend.withTokenAuthHeader(authentication.token)
        let response = await backend.internalApi.fetchEtaCalculatorEvents(
            context.companyId,
            eventId,
            pageSize,
            processed,
            (pageNumber) * pageSize,
            sortBy,
            sortDirection,
            transportOrderId,
            auth
        )
        setEtaCalculatorEvents(response.events)
        setTotalElements(response.count)
        setSelectedEvent("")
    }

    function emptySaveString(str: string | null | undefined): string | null {
        if (str === undefined || str === null || str.trim().length === 0) {
            return null
        }
        return str
    }

    function drawFilterSettings() {
        return <div>
            <Input
                type="text"
                style={{width: 320}}
                placeholder="Event ID"
                label={"Event ID"}
                value={eventId ?? ""}
                onChange={e => setEventId(e.target.value)}
            />
            <Input
                type="text"
                style={{width: 320}}
                placeholder="TransportOrderId"
                label={"TransportOrderId"}
                value={transportOrderId ?? ""}
                onChange={e => setTransportOrderId(emptySaveString(e.target.value))}
            />
            <Radio
                label="All"
                checked={processed === null}
                onChange={() => setProcessed(null)}
                style={{
                    marginLeft: 20,
                    marginRight: 10
            }}
            />
            <Radio
                label="Processed"
                checked={processed === true}
                onChange={() => setProcessed(true)}
                style={{marginRight: 10}}
            />
            <Radio
                label="unprocessed"
                checked={processed === false}
                onChange={() => setProcessed(false)}
                style={{marginRight: 20}}
            />
            <Button
                //disabled={transportOrderId == "" && eventId == "" }
                onClick={() => {
                    setLoading(true)
                    fetchData().then(() => setLoading(false))
                }
                }
            >
                Search
            </Button>
        </div>
    }

    function drawTable() {
        let columns = [
            {
                id: 'ID',
                Header: 'ID',
                width: 250,
                accessor: (d: BackendToEtaCalculatorEvent) => d._id
            },
            {
                id: 'Company ID',
                Header: 'Company ID',
                width: 250,
                accessor: (d: BackendToEtaCalculatorEvent) => d.companyId
            },
            {
                id: 'Transport Order ID',
                Header: 'Transport Order ID',
                width: 250,
                accessor: (d: BackendToEtaCalculatorEvent) => d.transportOrderId
            },
            {
                id: 'Processed',
                Header: 'Processed',
                width: 100,
                accessor: (d: BackendToEtaCalculatorEvent) => d.processed ? "Yes" : "No"
            },
            {
                id: 'Timestamp',
                Header: 'Timestamp',
                width: 150,
                accessor: (d: BackendToEtaCalculatorEvent) => formatDate(d.timestamp)
            },
        ]

        return (
            <ReactTable
                data={etaCalculatorEvents}
                pageSize={pageSize}
                page={pageNumber}
                showPagination={true}
                columns={columns}
                className="-striped -highlight custom-row-height"
                style={{cursor: "pointer"}}
                getTrProps={(state, rowInfo) => {
                    if (!rowInfo) return {};
                    return {
                        style: {
                            background: selectedEvent === JSON.stringify(rowInfo.original, null, 4)
                                ? "#d2eaff"
                                : "#f9f9f9",
                            color: "black"
                        }
                    };
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                    if (!rowInfo) return {};
                    return {
                        onClick: (e, handleOriginal) => {
                            setSelectedEvent(JSON.stringify(rowInfo.original, null, 4));
                        }
                    };
                }}
                onPageChange={page => setPageNumber(page)}
                onPageSizeChange={size => setPageSize(size)}
                onSortedChange={(newSorted, column) => {
                    if (newSorted && newSorted.length > 0) {
                        setSortBy(newSorted[0].id as 'ID' | 'COMPANY_ID' | 'PROCESSED' | 'TRANSPORT_ORDER_ID');
                        setSortDirection(newSorted[0].desc ? "DESC" : "ASC");
                        setLoading(true);
                        fetchData().then(() => setLoading(false));
                    }
                }}
                sorted={
                    [{
                        id: sortBy,
                        desc: sortDirection === "DESC"
                    }]
                }
                noDataText={loading ? "Loading..." : "No events found"}
                pages={Math.ceil(totalElements / pageSize)}
                manual
            />
        )
    }


    function drawJson() {
        return <AceEditor
            theme="monokai"
            mode="json"
            value={selectedEvent ?? ""}
            placeholder='select Event to see details'
            width='100%'
            height='100%'
            readOnly={true}
        />
    }

    function drawSplitter() {
        return <Splitter
            name={"EtaCalculatorEventSplitter"}
            left={drawTable()}
            right={drawJson()}
        />
    }

    return <>
        <h2>ETA Calculator Events</h2>
        {drawFilterSettings()}
        <hr/>
        {loading ? <div>Loading...</div> : drawSplitter()}

    </>
}